import moment from "moment"
import { cellValueExcel, RowExportTypeExcel } from "types"
import { excel } from "utils"
import { FormType } from "../utils"
import { PropsWithChildren } from "react"
import { DataCountType } from "../../types"

type ExportExcelAdjustmentInventoryProps = {
  countdetail: DataCountType["countdetail"]
  transaction_date: FormType["transaction_date"]
}

export function ExportExcelAdjustmentInventory(params: PropsWithChildren<ExportExcelAdjustmentInventoryProps>) {
  const columns = [
    { header: "#", key: "no", width: 5 },
    { header: "ITEM", key: "product_barcode", width: 20 },
    { header: "DESCRIPTION", key: "product_name", width: 30 },
    { header: "UNIT", key: "mr_unit_name", width: 15 },
    { header: "STOCK IN", key: "stock_in", width: 15 },
    { header: "STOCK OUT", key: "stock_out", width: 15 },
    { header: "RECAP IN CONVERTION UNIT IN", key: "recap_stock_in", width: 40 },
    { header: "RECAP IN CONVERTION UNIT OUT", key: "recap_stock_out", width: 40 },
    { header: "AVERAGE UNIT PRICE", key: "avarage", width: 20 },
    { header: "AMOUNT ADJUSTMENT", key: "amount", width: 20 },
    { header: "POSITION", key: "position", width: 20 },
    { header: "COA INVENTORY", key: "coa_inventory", width: 40 },
    { header: "COA EXPENCES/COGS", key: "coa_expences", width: 40 },
  ]

  const dataMap: RowExportTypeExcel[] = params?.countdetail?.map((item, index) => {
    return {
      no: index + 1,
      product_barcode: item?.product_barcode || "-",
      product_name: item?.product_name || "-",
      mr_unit_name: item?.mr_unit_name || "-",
      stock_in: numberFormat(item?.stock_in),
      stock_out: numberFormat(item?.stock_out),
      recap_stock_in: numberFormat(item?.stock_in * item?.quantity_unit_sell_convention),
      recap_stock_out: numberFormat(item?.stock_out * item?.quantity_unit_sell_convention),
      avarage: numberFormat(item?.avg_price_use),
      amount: numberFormat(item?.different * item?.avg_price_use),
      position: item?.position,
      coa_inventory: `${item.coa_inventory_code} - ${item.coa_inventory_name}`,
      coa_expences: `${item.coa_coex_code} - ${item.coa_coex_name}`,
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    title: "ADJUSTMENT INVENTORY", 
    module: "INVENTORY", 
    fileName: "adjustment_inventory",
    date: `${moment(params?.transaction_date).format('DD-MM-YYYY')}`
  })
}

function numberFormat(value: number): cellValueExcel {
  return {
    text: value,
    style: {
      alignment: { horizontal: "right" },
      numFmt: "#,##0"
    }
  }
}